module.exports = __webpack_public_path__ + "static/media/5.303e178c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/5.png
// module id = 505
// module chunks = 0